<template>
  <v-container fluid>
    <v-layout>
      <v-flex class="pb-4 ma-0" sm12>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-content>
            <template v-slot:header>
              <div>
              <h3>Search and Filter  <small v-if="panel !== 0" color="primary white"><em>(click to expand)</em></small>
                </h3>
              </div>
            </template>
            <v-card class="pa-4">
              <v-layout>
                <v-flex class="pa-2" sm12 md3>
                  <v-text-field v-if="form['filter-field'] != 'date'" id="keywordFilter" clearable label="Search Text"
                    placeholder="Enter keyword to search text" v-model="form.filter" @click:clear="init()"
                    @keydown.enter="doSearch()">
                  </v-text-field>

                </v-flex>
                <v-flex class="pa-2" sm12 md3>
                  <v-select :items="filterFields" label="In Field" v-model="form['filter-field']" />
                </v-flex>
              </v-layout>

              <v-layout v-if="amazeUserCan('admin_view', 'dsec_calendar')" class="status">
                <v-flex class="pa-2 pb-4" xs12 sm12 md6>
                  <v-checkbox v-model="form.show_events_meeting" label="Only show events meeting."
                    hint="If checked, only events meeting will be visible in the results." persistent-hint></v-checkbox>

                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="pa-2 pt-4" sm12 md3>
                  <h4>Filter Events By Date</h4>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex row class="px-2 pb-0 pt-2" xs12 sm12 md12>
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">Enter a Start Date and End Date to filter results in a date range.
                    </div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="pa-2 pt-0" sm12 md3>
                  <v-menu v-model="form.start_date_menu" :close-on-content-click="true" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field clearable @click:clear="clearStartDate()" v-model="form.formatted_start_date"
                        label="Start Date" hint="MM/DD/YYYY format" persistent-hint prepend-icon="event" v-on="on"
                        :rules="dateRules" @blur="form.start_date = dateDB(form.formatted_start_date)"
                        @change="doSearch()">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_date" no-title :max="form.end_date"
                      @input="form.formatted_start_date = dateUser(form.start_date)"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="pa-2 pt-0" sm12 md3>
                  <v-menu v-model="form.end_date_menu" :close-on-content-click="true" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field clearable @click:clear="clearEndDate()" v-model="form.formatted_end_date"
                        label="End Date" hint="MM/DD/YYYY format" persistent-hint prepend-icon="event" v-on="on"
                        :rules="dateRules" @blur="form.end_date = dateDB(form.formatted_end_date)" @change="doSearch()">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_date" no-title :min="form.start_date"
                      @input="form.formatted_end_date = dateUser(form.end_date)"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="pa-2 pb-4" xs12 sm12 md6>
                  <v-switch xs12 sm12 md6 inset color="primary"
                    :hint="`${form.show_past_events ? 'Show events even if they have ended.' : 'Hide events that have ended or which are flagged as past events.'}`"
                    persistent-hint v-model="form.show_past_events"
                    :label="` Past Events Are ${form.show_past_events ? 'Visible' : 'Hidden'}`">
                  </v-switch>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <!-- DATA TABLE -->
    <v-data-table :headers="headers" :items="events" :pagination.sync="tablePagination" :total-items="totalEvents"
      :loading="loading" :rows-per-page-items="rowsPerPage" sort-icon="arrow_drop_down"
      class="elevation-1 amaze-data-table">
      <template slot="items" slot-scope="props">
        <tr>
          <td class="larger">{{ props.item.dsec_partner.name }}</td>
          <td class="activity larger bold font-weight-bold text-bold">
            {{ props.item.name }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <small><i v-bind="attrs" v-on="on" class="descrpopicon fas fa-info-circle"></i></small>
              </template>
              <p class="descrpop">
                <strong>{{ props.item.name }}</strong>
                <br />
                {{ props.item.description }}
              </p>
            </v-tooltip>
          </td>
          <td class="dates">
            <span v-if="props.item.start_date">
              {{ dateUser(props.item.start_date) }}
              <span v-if="props.item.end_date"> - {{ dateUser(props.item.end_date) }} </span>
            </span>
            <span v-else>
              {{ props.item.general_date }}
            </span>
          </td>
          <td class="location method">
            {{ eventMethodString(props.item.method) }}
          </td>
          <td class="location city">{{ props.item.city }}</td>
          <td class="location state">{{ props.item.state }}</td>
          <!-- <td v-if="amazeUserCan('admin_view', 'dsec_calendar')">
                    <v-chip :class="'p-' + props.item.admin_tracking.priority" label small v-if="props.item.admin_tracking && props.item.admin_tracking.priority" disabled>{{ props.item.admin_tracking.priority }}</v-chip>
                </td> -->
          <!-- <td v-if="amazeUserCan('admin_view', 'dsec_calendar')" class="status">
                    <v-chip label small disabled v-if="props.item.status" :class="'s-' + props.item.status">{{ props.item.status }}</v-chip>
                </td> -->
          <td v-if="amazeUserCan('admin_view', 'dsec_calendar')" class="status">
            <!-- <v-chip label small disabled v-if="props.item.admin_tracking.support_status" :class="'s-' + props.item.admin_tracking.support_status">{{ props.item.admin_tracking.support_status }}</v-chip> -->
            {{ props.item.admin_tracking.support_status }}
          </td>
          <td class="date created" v-if="amazeUserCan('admin_view', 'dsec_calendar')">
            {{ dateUser(props.item.created_at) }}
          </td>
          <td class="text-right layout px-0 cardActions">
            <v-menu class='cardMenu hidden-md-and-up' bottom left>
              <v-btn slot="activator" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <div>
                  <v-list-tile v-on:click="$emit('view-event', 'event-view', props.item)">
                    <v-list-tile-title>View Event</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-on:click="$emit('edit-event', 'event-form', props.item)"
                    v-if="eventOwner(props.item.dsec_partner.id)">
                    <v-list-tile-title>Edit Event</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-on:click="$emit('admin-event', 'admin-form', { ...props.item, return: 'close' })"
                    v-if="amazeUserCan('administer', 'dsec_calendar')">
                    <v-list-tile-title>Event Tracking</v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list>
            </v-menu>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <v-btn class="hidden-sm-and-down amaze-user-action" slot="activator"
                    @click="$emit('view-event', 'event-view', props.item)" icon>
                    <v-icon size="14">fa fa-eye</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>View Event</span>
            </v-tooltip>
            <v-tooltip top v-if="eventOwner(props.item.dsec_partner.id)">
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <v-btn class="hidden-sm-and-down amaze-user-action" v-if="eventOwner(props.item.dsec_partner.id)"
                    slot="activator" @click="$emit('edit-event', 'event-form', props.item)" icon>
                    <v-icon>$vuetify.icons.amaze-edit</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Edit Event</span>
            </v-tooltip>
            <v-tooltip top v-if="amazeUserCan('administer', 'dsec_calendar')">
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on">
                  <v-btn class="hidden-sm-and-down amaze-user-action" v-if="amazeUserCan('administer', 'dsec_calendar')"
                    slot="activator" @click="$emit('admin-event', 'admin-form', { ...props.item, return: 'close' })"
                    icon>
                    <v-icon size="14">fa fa-cog</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Event Tracking</span>
            </v-tooltip>
          </td>
        </tr>
      </template>

      <template slot="actions-prepend" v-if="amazeUserCan('admin_view', 'dsec_calendar')">
        <v-btn @click="downloadResults()" flat class="" v-if="amazeUserCan('admin_view', 'dsec_calendar')">
          <v-icon class="mr-2" small>fa fa-table</v-icon> <strong>Download Results</strong>
        </v-btn>
      </template>
    </v-data-table>
    <!-- END DATA TABLE -->

  </v-container>
</template>

<script>
import {
  EventBus
} from "@/components/Events/event-bus.js";
import DSECMixin from "./DSECMixin";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import Url from 'domurl';
import _ from 'lodash'
import FileSaver from "file-saver";

export default {
  mixins: [DSECMixin, permissionsMixin],

  data() {
    return {
      events: [],
      panel: false,
      defaultHeaders: [{
        text: 'Partner',
        value: 'partner'
      },
      {
        text: 'Event/Activity',
        value: 'name'
      },
      {
        text: 'Dates',
        value: 'start_date'
      },
      {
        text: 'Method',
        value: 'method'
      },
      {
        text: 'City',
        value: 'city'
      },
      {
        text: 'State',
        value: 'state'
      },
      {
        text: 'Support Status',
        value: 'admin_tracking->support_status'
      },
      // {
      //   text: 'Priority',
      //   value: 'admin_tracking->priority'
      // },
      // {
      //   text: 'Status',
      //   value: 'admin_tracking->status'
      // },
      {
        text: 'Created',
        value: 'created_at'
      },
      {
        text: '',
        value: null,
        sortable: false,
        align: 'center'
      }
      ],
      pagination: {},
      tablePagination: {},
      rowsPerPage: [15],
      totalEvents: 0,
      search: null,
      show_past_events: false,
      show_events_meeting: false,
      loading: false,
      admin: false,
      form: {
        "filter-field": "name",
        sort: "start_date",
        show_past_events: false
      },
      sortField: "",
      sortDirection: "",
      formatted_start_date: "",
      formatted_end_date: ""
    };
  },
  watch: {
    tablePagination: {
      handler(newval, oldval) {
        this.loadPage();
      },
      deep: true
    },
    form: {
      handler(newval, oldval) {
        this.doSearch();
      },
      deep: true
    }
  },
  computed: {
    headers() {
      // Super stupid simple, but assume that if the value contains "admin_tracking" it's for admins only.
      // This will hide priority and status for non-admin users.
      // TODO: As of 2022-01-19, we can no longer assume that admin fields are the only hidden fields.
      // We have to add a column for "Created", so this will require a new implementation.
      // return this.defaultHeaders.filter(field => this.amazeUserCan('administer', 'dsec_calendar') ? true : field.value && !field.value.includes('admin_tracking'));
      return this.defaultHeaders.filter(field => this.amazeUserCan('admin_view', 'dsec_calendar') ? true : field.value && !this.isPrivateColumn(field.value));
    },
    dateRules() {
      if ((this.form.start_date && !this.form.end_date) || (!this.form.start_date && this.form.end_date)) {
        return [v => !!v || 'Both start and end date are required in order to filter in a date range.'];
      }
      return [];
    },
    filterFields() {
      let fields = [{
        text: "Event/Activity",
        value: "name"
      },
      {
        text: "Partner",
        value: "partner"
      },
      {
        text: "Program",
        value: "program"
      },
      {
        text: "Description",
        value: "description"
      },
      {
        text: "Venue",
        value: "venue"
      },
      {
        text: "City",
        value: "city"
      },
      {
        text: "State",
        value: "state"
      }
      ];

      if (this.amazeUserCan('administer', 'dsec_calendar')) {
        fields.push({
          text: "Support Status",
          value: "admin_tracking->support_status"
        });
        // fields.push({
        //   text: "Priority",
        //   value: "admin_tracking->priority"
        // });
        // fields.push({
        //   text: "Status",
        //   value: "admin_tracking->status"
        // });
        // There wasn't a request to search by
        // date created, but if that changes,
        // we can add it here.
        // fields.push({
        //   text: "Created",
        //   value: "created_at"
        // });
        fields.push({
          text: "Funding Mechanism",
          value: "admin_tracking->funding_mechanism"
        });
      }
      return fields;
    }
  },
  methods: {
    clearStartDate() {
      this.form.start_date = null; this.doSearch();
    },
    clearEndDate() {
      this.form.end_date = null; this.doSearch();
    },
    load: _.debounce(async function (url) {
      this.loading = true;
      let eventData = await this.$http.get(url);
      let {
        data,
        ...pagination
      } = eventData.body;
      this.events = data;
      this.pagination = _.merge(this.pagination, pagination);
      this.pagination["current_url"] = url;
      this.totalEvents = eventData.body.total;
      this.loading = false;
    }, 500),
    refresh() {
      this.load(this.pagination.current_url);
    },
    loadPage() {
      let url = this.getQueryUrl();
      this.load(`dsec/events?${url.query}`);
    },
    getQueryUrl() {
      let visit = this.pagination.current_url || this.pagination.path || "dsec/events";
      let url = new Url(visit);

      const {
        sortBy,
        descending,
        page
      } = this.tablePagination;
      const sortOrder = descending ? 'desc' : 'asc';

      var field = this.form["filter-field"];
      var term = this.form["filter"];
      var pastEvents = this.form["show_past_events"];
      var eventsMeeting = this.form["show_events_meeting"];

      url.query.sort = sortBy;
      url.query['sort-dir'] = sortOrder;
      url.query.page = page;
      url.query['past'] = this.form["show_past_events"];
      url.query.date = new Date().toJSON().slice(0, 10);

      // Infer field from existance of dates.
      if (this.form.start_date && this.form.end_date) {
        // Add support for date filtering.
        url.query.start_date = this.form.start_date;
        url.query.end_date = this.form.end_date;
      } else {
        delete url.query.start_date;
        delete url.query.end_date;
      }

      if (eventsMeeting) {
        url.query.meeting = 1;
      } else {
        delete url.query.meeting;
      }

      if (pastEvents) {
        url.query.past = true;
      } else {
        delete url.query.past;
      }

      // First check that a value has been entered for the field selected for filtering.
      if (term && field) {
        url.query['filter-field'] = field;
        url.query.filter = term;
      } else {
        delete url.query['filter-field'];
        delete url.query.filter;
      }

      return url;
    },
    doSearch() {
      let url = this.getQueryUrl();
      let query = url.query;

      if (query.length > 0) {
        query = query.reduce(function (x, y) { return x + '&' + y; });
        this.load(`dsec/events?${query}`);
      } else {
        this.loadPage("dsec/events");
      }
    },
    async downloadResults() {
      let url = this.getQueryUrl();
      let query = url.query;

      let file = await this.$http.post(
        "dsec/filtered-export",
        query,
        { responseType: "blob" }
      );
      FileSaver.saveAs(file.data, "EventTable[" + _.kebabCase(_.pickBy(query, (value, key) => !key.includes('sort'))) + "].xlsx");
    },
    init() {
      this.loadPage();
    },
    isPrivateColumn(col) {
      return col.includes('admin_tracking') || ["created_at"].includes(col);
    }
  },
  mounted() {
    this.init();
    EventBus.$on("refreshEvents", this.refresh);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/dsec-labels.scss";

.v-btn--flat {
  font-weight: normal;
}

.amaze-table tr:not(.no-hover):not(.pagination):hover {
  cursor: pointer;
}

.v-input__icon--append .v-icon {
  color: $icon-blue;
}

td {
  &.contact {
    span {
      white-space: nowrap;
    }
  }

  &.dates {
    min-width: 10em;
  }

  &.activity {
    min-width: 25em;
  }
}

.descrpop {
  max-width: 25rem;
}

::v-deep .descrpopicon {
  font-size: 12px;
}

::v-deep table.v-table {

  tbody,
  thead {

    td,
    th {
      margin: 5px 0;
    }
  }
}

::v-deep ul.v-expansion-panel {
  margin-left: 0px !important;
  margin-right: 0px !important;

  .li.v-expansion-panel__container {
    margin-left: 0px;
    margin-right: 0px;
  }
}

::v-deep .v-datatable__actions {
  justify-content: flex-start;
  div:first-of-type {
    flex-grow: 1;
  }
}

@media (max-width: 720px) {
  .layout {
    display: block !important;

    .sm12 {
      width: 100% !important;
      min-width: 100% !important;
    }
  }
}
</style>
